import { Component, OnInit } from '@angular/core';
import { MenuService } from './menu.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'digitalcom';
  pageInit: boolean = false;

  constructor(public menuCtrl: MenuService, public router: Router) {
    
  }

  ngOnInit() {
    this.pageInit = true;
    if (this.menuCtrl.getActivePage() != '/home' && this.menuCtrl.getActivePage() != '/index' && this.menuCtrl.getActivePage() != '' && this.menuCtrl.getActivePage() != '/') {
      console.log('not home', this.menuCtrl.getActivePage())
      this.menuCtrl.pageTransOut();
    }
  }
}
